import { render, staticRenderFns } from "./CustomerContextProductChip.vue?vue&type=template&id=5b698163&scoped=true"
import script from "./CustomerContextProductChip.vue?vue&type=script&lang=js"
export * from "./CustomerContextProductChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b698163",
  null
  
)

export default component.exports